import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignDesignInputUserNeed } from '../Product.hooks';
import {
  ProductUserNeed,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignUserNeedDialog from './AssignUserNeedDialog';

export type DesignInputAssignUserNeedDialogProps = BaseProductAssignDialogProps<'designInputId'>;

const DesignInputAssignUserNeedDialog: React.FC<DesignInputAssignUserNeedDialogProps> = (
  props: DesignInputAssignUserNeedDialogProps
) => {
  const {
    open,
    productId,
    designInputId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductDesignInput,
    isAssigning,
    error: assignError,
    assignUserNeeds
  } = useAssignDesignInputUserNeed(productId, designInputId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductDesignInput) {
      onAssigned?.(updatedProductDesignInput);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductDesignInput]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignUserNeedDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'userNeed'
      )} to assign to the ${getProductEntityName('designInput')}.`}
      onSubmit={(userNeeds: ProductUserNeed[]) => {
        assignUserNeeds({
          userNeedIds: userNeeds.map((userNeed: ProductUserNeed) => userNeed.id)
        });
      }}
    />
  );
};

export default DesignInputAssignUserNeedDialog;
